import styled from 'styled-components'

import HollowPin from 'components/icons/HollowPin'
import {
  AutocompleteDropdownResult,
  DropDownWrapper,
  DropdownTitle,
} from '../styles'

const IconWrapper = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-neutral-200']?.value};
  padding: 16px;
  margin-right: 16px;
  border-radius: 4px;
  display: flex;

  svg {
    height: 24px;
  }

  + div {
    flex: 1;
  }
`

interface LocationItemProps {
  title: string
  onClick: () => any
}

const LocationItem = ({ title, onClick }: LocationItemProps) => (
  <AutocompleteDropdownResult className="qa-result" onClick={onClick}>
    <IconWrapper>
      <HollowPin />
    </IconWrapper>

    <DropDownWrapper>
      <DropdownTitle>{title}</DropdownTitle>
    </DropDownWrapper>
  </AutocompleteDropdownResult>
)

export default LocationItem
